export const ContactVerificationSuccessAction = {
  ResumeWithdraw: 'resumeWithdraw',
  GoToProfile: 'goToProfile',
} as const;

export type ContactVerificationSuccessAction =
  (typeof ContactVerificationSuccessAction)[keyof typeof ContactVerificationSuccessAction];

export type ContactVerificationSuccessPayload = {
  successAction: ContactVerificationSuccessAction;
};
